import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "react-feather";

const ButtonBack = () => {
    const navigate = useNavigate();

    return (
        <span onClick={() => navigate(-1)} className="filter-invert-color btn-back btn-dark cursor-pointer" id="btn-close-modal">
            <ArrowLeft className="icon-back"/>
        </span>
    );
};

export default ButtonBack;
